import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'System|Pages|Session Expired';

export type SpSessionExpiredLocs =
	| 'SPSystemSessionExpiredTitle'
	| 'SPSystemSessionExpiredContent'
	| 'SPSystemSessionExpiredButton';

export type CpSessionExpiredLocs =
	| 'CPSystemSessionExpiredTitle'
	| 'CPSystemSessionExpiredContent'
	| 'CPSystemSessionExpiredButton';

const sharedData: {
	title: Omit<LocDef, 'feature' | 'type' | 'portal'>;
	content: Omit<LocDef, 'feature' | 'type' | 'portal'>;
	button: Omit<LocDef, 'feature' | 'type' | 'portal'>;
} = {
	title: {
		defaultValue: 'Session Expired',
		displayPath: `${dpRoot}|Title`,
		description: 'Title for the session expired page.',
		displayType: 'Title',
		htmlAllowed: false,
		shared: false,
	},
	content: {
		defaultValue: 'Your session has expired.',
		displayPath: `${dpRoot}|Content`,
		description:
			'Content displayed on the session expired page. Leave blank to just display the title and button.',
		displayType: 'Content',
		htmlAllowed: true,
		shared: false,
	},
	button: {
		defaultValue: 'Log In Again',
		displayPath: `${dpRoot}|Button`,
		description: 'Text displayed in the go back button.',
		displayType: 'Button',
		htmlAllowed: false,
		shared: false,
	},
};

const sharedSpData: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.Core,
	portal: 'SP',
};

const sharedCpData: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.CandidateAccess,
	portal: 'CP',
};

export const spSessionExpiredLocs: LocDefs<SpSessionExpiredLocs> = {
	SPSystemSessionExpiredTitle: {
		...sharedSpData,
		...sharedData.title,
	},
	SPSystemSessionExpiredContent: {
		...sharedSpData,
		...sharedData.content,
	},
	SPSystemSessionExpiredButton: {
		...sharedSpData,
		...sharedData.button,
	},
};

export const cpSessionExpiredLocs: LocDefs<CpSessionExpiredLocs> = {
	CPSystemSessionExpiredTitle: {
		...sharedCpData,
		...sharedData.title,
	},
	CPSystemSessionExpiredContent: {
		...sharedCpData,
		...sharedData.content,
	},
	CPSystemSessionExpiredButton: {
		...sharedCpData,
		...sharedData.button,
	},
};

export const LOC_KEYS = MapLocKeys<SpSessionExpiredLocs | CpSessionExpiredLocs>({
	...spSessionExpiredLocs,
	...cpSessionExpiredLocs,
});
export type SessionExpiredLocType = LocMap<SpSessionExpiredLocs | CpSessionExpiredLocs>;
